import { toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("button", {
    class: "scroll-to-content-button",
    type: "button",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollToContent && _ctx.scrollToContent(...args)))
  }, _toDisplayString(_ctx.text), 513 /* TEXT, NEED_PATCH */)), [
    [_vShow, _ctx.hasContent]
  ])
}